import {
    LOGIN_FAILURE,
    LOGIN_SUCCESS,
    LOGOUT
} from "../actionType";

const initialState = {
    isAuthenticated: false,
    token: null,
    user: null,
    error: null
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case LOGIN_SUCCESS:
            return {
                ...state,
                isAuthenticated: true,
                token: action.payload.token,
                user: action.payload.user,
                error: null,
            };
        case LOGIN_FAILURE:
            return {
                ...state,
                isAuthenticated: false,
                token: null,
                user: null,
                error: 'Login failed',
            };
        case LOGOUT:
            return {
                ...state,
                isAuthenticated: false,
                token: null,
                user: null,
                error: null
            };
        default:
            return state;
    }
};
